import { section } from "@/glow";
import { qs, qsa, listen, remove, contains } from "@fluorescent/dom";
import { animateTabbedCollections, shouldAnimate } from "@/lib/animation";
import ProductItem from "@/lib/product-item";
import { activateTemplate } from "@/lib/templates";

const selectors = {
  navItems: "[data-tab-button]",
  sliderContainer: ".featured-collection-slider-grid",
};

const classes = {
  selected: "selected",
  active: "active",
  fadeout: "fadeout",
  initReveal: "init-reveal",
  reveal: "reveal",
};

section("tabbed-collections", {
  onLoad() {
    this.events = [];
    this.productItem = ProductItem(this.container);
    this.navItems = qsa(selectors.navItems, this.container);

    this.navItems.forEach(button =>
      this.events.push(
        listen(button, "click", this._handleNavButton.bind(this))
      )
    );

    if (shouldAnimate(this.container)) {
      this.animateTabbedCollections = animateTabbedCollections(this.container);
    }
  },

  _handleNavButton(e) {
    e.preventDefault();
    const { showsCollectionKey } = e.currentTarget.dataset;

    if (!contains(e.currentTarget, classes.selected)) {
      this._hideAll();
      this._show(showsCollectionKey);
    }
  },

  _hideAll() {
    const sliderElements = qsa(selectors.sliderContainer, this.container);
    remove(this.navItems, classes.selected);
    remove(sliderElements, classes.active);
  },

  _show(key) {
    activateTemplate(key, { resolveOnMissing: true }).then(data => {
      if (data?.wasInjected) {
        this.productItem = ProductItem(this.container, { afterLoad: true });
        if (shouldAnimate(this.container)) {
          this.animateTabbedCollections = animateTabbedCollections(
            this.container
          );
        }
      }
      const collection = qs(`[data-collection-key="${key}"]`, this.container);

      collection.classList.add(classes.active);
      if (this.navItems.length) {
        const navigationItem = qs(
          `[data-shows-collection-key="${key}"]`,
          this.container
        );
        navigationItem?.classList.add(classes.selected);
      }
    });
  },

  onUnload() {
    this.productItem && this.productItem.unload();
    this.animateTabbedCollections?.destroy();
    this.events.forEach(unsubscribe => unsubscribe());
  },

  onBlockSelect({ target }) {
    const { collectionKey } = target.dataset;
    this._hideAll();
    this._show(collectionKey);
  },
});
